import get from 'lodash/get';
import { request } from 'lib';
import { UiToast, UiModal } from 'components';
import { getGlobalStore, globalStore } from 'stores';
import { getStore } from '../store';

// 接口文档
// https://mock.memeyule.com/project/16/interface/api/24101

const loadInfo = () => {
  const {
    room: { roomInfo, roomId },
    lianmai: { racePk },
  } = getStore();
  request.cryolite
    .get('/api/v1/racepk/info', {
      room_id: roomId,
    })
    .then((res) => {
      const { mode_info } = res.data;
      // {
      //     "pk_duration": 120,
      //     "mode_info": {
      //       "id": "6916db89b9631419da99579a",
      //       "stage": 3,
      //       "stage_desc": "PK惩罚中",
      //       "duration": 30,
      //       "remain_time": 29,
      //       "multi_pk_info": [
      //         {
      //           "room_id": 100000001,
      //           "pk_value": 0,
      //           "pk_result": 3,
      //           "nickname": "100000001",
      //           "pic": "https://test-img.sumeme.com/34/2/1576317482914.jpeg"
      //         },
      //         {
      //           "room_id": 100000002,
      //           "pk_value": 0,
      //           "pk_result": 3,
      //           "nickname": "100000002",
      //           "pic": "https://test-img.sumeme.com/34/2/1576317482914.jpeg"
      //         }
      //       ]
      //     }
      //   }
      // 按照 live_streams 顺序排序
      if (roomInfo.isRacePk && mode_info && mode_info.multi_pk_info) {
        mode_info.multi_pk_info = roomInfo.live_streams.map((item) => {
          return mode_info.multi_pk_info.find((item2) => {
            return item2.room_id === item.uid;
          });
        });
      }

      racePk.updateInfo(res.data);
    });
};

// 关播时退出
const liveOffExit = () => {
  const info = get(getStore(), 'lianmai.racePk.info') || {};

  if (info.isMatching) {
    cancelMatch();
  }
  if (info.isInPk) {
    UiToast.fail('正在PK大乱斗中，请先退出');
    throw new Error('正在PK大乱斗中，请先退出');
  }
};

const joinMatch = () => {
  request.cryolite
    .post('/api/v1/racepk/match', null, {
      event: 'racePk',
      event_type: 'joinMatch',
      desc: '发起匹配',
    })
    .then((res) => {
      reload();
      UiToast.success(res.msg || '已发起匹配');
    })
    .catch((res) => {
      reload();
      UiToast.fail(res.msg || '操作异常');
    });
};

const cancelMatch = (matchingId) => {
  request.cryolite
    .post(
      '/api/v1/racepk/match/cancel',
      {
        matchingId,
      },
      {
        event: 'racePk',
        event_type: 'cancelMatch',
        desc: '取消匹配',
      },
    )
    .then((res) => {
      reload();
      UiToast.success(res.msg || '已取消匹配');
    })
    .catch((res) => {
      reload();
      UiToast.fail(res.msg || '操作异常');
    });
};

const reload = () => {
  loadInfo();
};

export default {
  loadInfo,
  liveOffExit,
  joinMatch,
  cancelMatch,
  reload,
};
